import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3604 10.7199V17.696C8.48041 17.3759 6.24042 14.9439 6.24042 11.9999C6.24042 10.2719 7.0084 8.67195 8.28843 7.64792L11.3604 10.7199Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7604 11.9999C17.7604 14.9439 15.5204 17.4399 12.6404 17.696V10.7199L15.7124 7.64792C16.9924 8.67195 17.7604 10.2719 17.7604 11.9999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4644 4.89593L16.6724 6.68788C18.1444 7.96791 19.0404 9.88788 19.0404 11.9999C19.0404 15.9039 15.9044 19.0399 12.0004 19.0399C8.09638 19.0399 4.96039 15.9039 4.96039 11.9999C4.96039 9.88788 5.92041 8.03192 7.3284 6.68788L5.53639 4.89593C3.6164 6.68788 2.40039 9.18392 2.40039 11.9999C2.40039 17.3119 6.68839 21.5999 12.0004 21.5999C17.3124 21.5999 21.6004 17.3119 21.6004 11.9999C21.6004 9.18392 20.3844 6.68788 18.4644 4.89593Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0004 8.7999C13.7677 8.7999 15.2004 7.3672 15.2004 5.5999C15.2004 3.8326 13.7677 2.3999 12.0004 2.3999C10.2331 2.3999 8.80035 3.8326 8.80035 5.5999C8.80035 7.3672 10.2331 8.7999 12.0004 8.7999Z",
			fill: "white"
		})
	]
});
export default SvgLogoMenu;
